<template>
    <div class="flex items-center relative">
        {{ deliveryRate }}
    </div>

</template>

<script>

/* Note, this was copied / renamed from MessageTableStatus. So we can just update the Sent Message Table first */

export default {
    name: "MessageSentTableDeliveryRate",
    props: {
        meta: {
            type: Object,
            default: () => {}
        },
        name: {
            type: String,
            default: ""
        },
        data: {
            type: Object,
            default: () => {}
        },
    },
    components: { },
    data: () => ({
    }),
    computed: {
        deliveryRate() {
            if (!this.data.message_status_counts) {
                return '--';
            }
            let percent = this.data.message_status_counts.delivered / this.data.message_status_counts.total * 100;
            if (this.data.media) {
                //in this case, percent should be total minus failed
                percent = (this.data.message_status_counts.total - this.data.message_status_counts.failed) / this.data.message_status_counts.total * 100;
            }
            return percent.toFixed(0) + '%';
        }
    },
    mounted() {

    },
    methods: {},
};
</script>

<style scoped lang="scss">


</style>
